import React, { useState } from 'react'

function AccidentCover() {
    const [benefits, setBenefits] = useState({
        OwnerDriverPACover: false,
        PaidDriverCover: false,
        oneLacUnnamedPassengerCover: false,
    });

    const toggleCheckbox = (disease) => {
        setBenefits(prevState => ({
            ...prevState,
            [disease]: !prevState[disease]
        }));
    };
    return (
        <>
            <div className='conatiner'>
                <div className='row'>
                    <div className='col-12'>
                        <h4>AddOns benefits</h4>
                        <p>These benefits are part of your insurance cover. You can check plans as per your desired benefits</p>
                    </div>
                    <div className='col-6 mt-2'>
                        <div className={`custom-checkbox-disease ${benefits.OwnerDriverPACover ? 'checked' : ''}`} onClick={() => toggleCheckbox('OwnerDriverPACover')}>
                            <div className="checkbox-disease">
                                {benefits.OwnerDriverPACover && <span className="checkmark-disease">&#10003;</span>}
                            </div>
                            <div className="label" style={{fontSize:'14px'}}>Owner-Driver PA Cover</div>
                        </div>
                    </div>
                    <div className='col-6 mt-2'>
                        <div className={`custom-checkbox-disease ${benefits.PaidDriverCover ? 'checked' : ''}`} onClick={() => toggleCheckbox('PaidDriverCover')}>
                            <div className="checkbox-disease">
                                {benefits.PaidDriverCover && <span className="checkmark-disease">&#10003;</span>}
                            </div>
                            <div className="label" style={{fontSize:'14px'}}>Paid Driver Cover</div>
                        </div>
                    </div>
                    <div className='col-6 mt-2'>
                        <div className={`custom-checkbox-disease ${benefits.oneLacUnnamedPassengerCover ? 'checked' : ''}`} onClick={() => toggleCheckbox('oneLacUnnamedPassengerCover')}>
                            <div className="checkbox-disease">
                                {benefits.oneLacUnnamedPassengerCover && <span className="checkmark-disease">&#10003;</span>}
                            </div>
                            <div className="label" style={{fontSize:'14px'}}>₹1 Lac Unnamed Passenger Cover</div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AccidentCover